import { create } from "zustand"

type FilterStore = {
  unreadCount: number
  setUnreadCount: (f: number) => void
}

export const useChatCountsStore = create<FilterStore>((set, get) => ({
  unreadCount: 0,
  setUnreadCount: (f: number) => {
    set(() => ({ unreadCount: f }))
  },
}))
